<h2>{{ 'our_team_title' | translate }}</h2>
<div class="container-team">
    <div class="flex-column-center-center" *ngFor="let item of teamModel">
        <picture>
            <source srcset="{{item.imageUrl}}.webp" type="image/webp" />
            <img width="200" height="200" src="{{item.imageUrl}}.png" alt="{{item.description}}">
        </picture>

        <div class="text-team">
            <h4>{{item.name}}</h4>
            <h5>{{item.description}}</h5>
        </div>
    </div>
</div>
